<div class="slider-item-chronology-container" *ngIf="article.type == 'article'" [style]="getBackImage(showContent)"
     (scroll)="allowScroll($event)"
     (wheel)="allowScroll($event)"
>
    <div class="slider-item-chronology-title-container">
        <div class="slider-item-chronology-title" *ngIf="showContent">
            {{ article.title }}
        </div>
        <div class="slider-item-chronology-subtitle"
             *ngIf="article.subTitle && showContent"
             [style]="(article.images != undefined && (article.images.length > 0)) ? 'color: white;' : 'color: black'"
        >
            {{ article.subTitle }}
        </div>
    </div>
    <div class="slider-item-chronology-text-container">
        <div class="slider-item-chronology-text" *ngIf="showContent">
            <p class="paragraph" (touchstart)="onChildTouch($event, true)"
               [style]="(article.images != undefined && (article.images.length > 0)) ? 'color: white;' : 'color: black'">
                {{ article.text }}
            </p>
        </div>
    </div>
    <div class="slider-item-chronology-show-button" *ngIf="article.images != undefined && article.images.length > 0 && !this.isMobile">
        <app-icon [icon]="Icons.show" (click)="$event.stopPropagation(); showContent = !showContent"/>
    </div>
    <div *ngIf="activeButtons()" class="button-slider">
        <app-icon (click)="$event.stopPropagation(); clickImgs(-1)" class="button-slider-icon button-slider-icon-left"
                  [icon]="Icons.buttonArrow"/>
        <app-icon (click)="$event.stopPropagation(); clickImgs(1)" class="button-slider-icon" [icon]="Icons.buttonArrow"/>
    </div>
</div>
<div class="slider-item-hero-container" *ngIf="article.type == 'hero'">
    <div class="slider-item-hero-img-container">
        <div *ngIf="article.image" class="slider-item-hero-img">
            <img [src]="getImageUrl(article.image ?? '')" alt="hero">
        </div>
    </div>
    <div class="slider-item-hero-text-container">
        <div class="slider-item-hero-text-title">
            {{ article.title }}
        </div>
        <!--        <div class="slider-item-hero-text-subtitle">-->
        <!--            {{ article.subTitle }}-->
        <!--        </div>-->
        <div class="slider-item-hero-text-text">
            <p class="paragraph" style="color: #000000;" (touchstart)="onChildTouch($event, true)">
                {{ article.subTitle }}<br>
                {{ article.text }}<br>
                © Государственный архив Ярославской области
            </p>
        </div>
    </div>
</div>
<div class="slider-item-hero-main-container" *ngIf="article.type == 'hero-main'">
    <div class="slider-item-hero-main">
        <div class="slider-item-hero-main-title">
            {{ article.title }}
        </div>
        <div class="slider-item-hero-main-text">
            <p class="paragraph" (touchstart)="onChildTouch($event, true)" style="color: #000000;">
                {{ article.text }}
            </p>
        </div>
    </div>
</div>


<!--<div *ngIf="article.type == 'article'" class="slider-item-container" [style]="getBackImage(true)"-->
<!--     (scroll)="allowScroll($event)"-->
<!--     (touchend)="allowScroll($event)"-->
<!--     (touchmove)="allowScroll($event)"-->
<!--     (touchstart)="allowScroll($event)"-->
<!--     (wheel)="allowScroll($event)"-->
<!--&gt;-->
<!--    <div class="title-container">-->
<!--&lt;!&ndash;        <div class="title" *ngIf="showContent" [style]="(article.imgs != undefined && (article.imgs.length > 0)) ? 'color: #e83127;' : 'color: black'">&ndash;&gt;-->
<!--        <div class="title" *ngIf="showContent">-->
<!--            {{ article.title }}-->
<!--        </div>-->
<!--        <div-->
<!--                *ngIf="article.subTitle && showContent"-->
<!--                class="subtitle"-->
<!--                [style]="(article.imgs != undefined && (article.imgs.length > 0)) ? 'color: white;' : 'color: black'">-->
<!--            {{ article.subTitle }}-->
<!--        </div>-->
<!--    </div>-->
<!--    <div class="text-container">-->
<!--        <div class="text">-->
<!--            <p class="paragraph"-->
<!--                    *ngIf="showContent"-->
<!--                    [style]="(article.imgs != undefined && (article.imgs.length > 0)) ? 'color: white;' : 'color: black'"-->
<!--            >-->
<!--                {{ article.text }}-->
<!--            </p>-->
<!--        </div>-->
<!--    </div>-->
<!--    <div *ngIf="activeButtons()" class="button-slider">-->
<!--        <app-icon (click)="clickImgs(-1)" class="button-slider-icon button-slider-icon-left" [icon]="Icons.buttonArrow"/>-->
<!--        <app-icon (click)="clickImgs(1)" class="button-slider-icon" [icon]="Icons.buttonArrow"/>-->
<!--    </div>-->
<!--    <div class="text-show-button">-->
<!--        <div class="button" style="width: 56px; height: 56px" *ngIf="article.imgs != undefined && article.imgs.length > 0">-->
<!--            <app-icon [icon]="Icons.show" (click)="showContent = !showContent"/>-->
<!--        </div>-->
<!--    </div>-->
<!--</div>-->

<!--<div *ngIf="article.type == 'hero'" class="slider-item-container" >-->
<!--    <div class="slider-item-hero-container">-->
<!--        <div class="hero-img-container">-->
<!--            <div class="hero-img" (click)="selectHero()" [style]="getBackImage(false)" [class]="getClass()"></div>-->
<!--        </div>-->
<!--        <div class="title-container" style="padding: 0">-->
<!--            <div class="title title-hero">-->
<!--                {{ article.title }}-->
<!--            </div>-->
<!--            <div *ngIf="article.subTitle " class="subtitle-hero">-->
<!--                {{ article.subTitle }}-->
<!--            </div>-->
<!--            <div *ngIf="article.text" class="text">-->
<!--                {{ article.text}}-->
<!--                <br>-->
<!--            </div>-->
<!--            <div class="text">-->
<!--                © Государственный архив Ярославской области-->
<!--            </div>-->
<!--        </div>-->
<!--    </div>-->
<!--</div>-->
<!--<div *ngIf="article.type == 'hero-main'" class="slider-item-container">-->
<!--    <div class="title-container-hero-main">-->
<!--        <div class="title title-hero">-->
<!--            {{ article.title }}-->
<!--        </div>-->
<!--        <div *ngIf="article.subTitle " class="subtitle-hero">-->
<!--            {{ article.subTitle }}-->
<!--        </div>-->
<!--        <div *ngIf="article.text" class="text" [style]="article.miniText ? 'margin-top: 1vh;' : ''">-->
<!--            {{ article.text}}-->
<!--        </div>-->
<!--    </div>-->
<!--&lt;!&ndash;    <div class="col-7">&ndash;&gt;-->
<!--&lt;!&ndash;        <div class="hero-img-container" style="width: 70%">&ndash;&gt;-->
<!--&lt;!&ndash;            <div class="hero-img" [style]="getBackImage(false)" [class]="getClass()">&ndash;&gt;-->

<!--&lt;!&ndash;            </div>&ndash;&gt;-->
<!--&lt;!&ndash;        </div>&ndash;&gt;-->
<!--&lt;!&ndash;    </div>&ndash;&gt;-->
<!--</div>-->

